import React, { useEffect, useMemo } from 'react';
import { ColumnCategory, PrimaryCategoryData } from 'types';
import { checkStores } from 'utility/utility';

interface L2Props {
  L1LinksData: PrimaryCategoryData | null;
  L2LinksData: ColumnCategory | null;
  keyBoardNavigation: boolean;
}

const L2Links = ({ L2LinksData, L1LinksData, keyBoardNavigation }: L2Props) => {
  useEffect(() => {
    if (keyBoardNavigation) {
      document.getElementById('l2Link-0')?.focus();
    }
  }, [L2LinksData]);

  const dataEmTagShopAll = useMemo(
    () =>
      `TopNav_${(L1LinksData?.title ?? '').replace(/ /g, '')}_${L2LinksData?.n.replace(
        / /g,
        '',
      )}_ShopAll`,
    [L2LinksData],
  );

  const dataEmTagL2Link = (l2Link: string) =>
    L2LinksData?.n.includes('Featured')
      ? `TopNav_Featured:${(L1LinksData?.title ?? '').replace(/ /g, '')}_${L2LinksData?.n.replace(
          / /g,
          '',
        )}_${l2Link.replace(/ /g, '')}`
      : `TopNav_${(L1LinksData?.title ?? '').replace(/ /g, '')}_${L2LinksData?.n.replace(
          / /g,
          '',
        )}_${l2Link.replace(/ /g, '')}`;

  const shopAllButton = useMemo(
    () =>
      L2LinksData?.ch &&
      L2LinksData?.ch.length > 0 &&
      L2LinksData.ch
        .filter((l2Link) => l2Link.n.replace(/\s/g, '').toLowerCase() === 'shopall')
        .map((l2Link) => (
          <a
            key={`l2ShopAll-${l2Link.n}`}
            className="hmf-body-bold-s shop-all hmf-px-s hmf-py-xxs hmf-ml-s hmf-text-transform-uppercase hmf-display-flex hmf-align-items-center hmf-justify-content-center"
            id="shopAllL2"
            tabIndex={0}
            href={checkStores(l2Link.u)}
            data-em={dataEmTagShopAll}>
            Shop All
          </a>
        )),
    [L2LinksData],
  );

  const links = useMemo(
    () =>
      L2LinksData?.ch &&
      L2LinksData?.ch.length > 0 &&
      L2LinksData.ch
        .filter((l2Link) => l2Link.n.replace(/\s/g, '').toLowerCase() !== 'shopall')
        .map((l2Link, index) => (
          <a
            key={`l2Link-${l2Link.n}`}
            className="l0-link-content hmf-px-s hmf-py-xxs title-color hmf-body-l"
            id={`l2Link-${index}`}
            tabIndex={0}
            aria-label={`Open ${l2Link.n}`}
            href={checkStores(l2Link.u)}
            data-em={dataEmTagL2Link(l2Link.n)}>
            {l2Link.n}
          </a>
        )),
    [L2LinksData, checkStores],
  );

  return (
    <div
      className="l2-links-container hmf-display-flex"
      data-testid="l2LinksContainer"
      id="l2LinksContainer">
      <div className="links-body">
        <div className="hmf-px-s hmf-pb-xs hmf-pt-xxs hmf-display-flex hmf-justify-content-between hmf-align-items-center">
          <span className="links-title label-base hmf-header-bold-m">{L2LinksData?.n}</span>
          {shopAllButton}
        </div>
        <div className="l2-links-body-container hmf-display-flex hmf-flex-column hmf-px-xlg-m hmf-pb-0 hmf-pb-xlg-xxxl">
          {links}
        </div>
      </div>
    </div>
  );
};

export default L2Links;
